/**
 * 前端统一配置入口
 * 环境变量通过 webpack 注入，运行时通过 api.config.js 动态判断
 */

import apiConfig from './api.config'

// 当前环境（由 webpack DefinePlugin 注入）
const ENV = process.env.NODE_ENV || 'development'
const IS_DEV = ENV === 'development'
const IS_PROD = ENV === 'production'

// API 基础配置 - 从 api.config.js 导入
const API_CONFIG = {
  baseURL: apiConfig.baseURL,
  serverBase: apiConfig.serverBase,
  timeout: 10000,
  ...apiConfig
}

// 应用配置
const APP_CONFIG = {
  name: 'RoviaSys',
  // 系统品牌单一来源（2026-09-11 两层分离）：systemBrandName/Zh = 软件产品品牌（RoviaSys 路维智联），
  // 只用于系统位——footer copyright、admin-lite、MCP 身份、title 兜底。
  // 店铺展示名走后端 system_config.platform_name（super_admin 在系统设置配置，空=未配置），
  // 业务页面欢迎语/title 后缀读它（publicConfig），禁止 fallback 到系统品牌。
  // 项目内部标识（仓库/容器/数据库/API）仍是 platoSys/plato，与展示层解耦。
  systemBrandName: 'RoviaSys',
  systemBrandNameZh: '路维智联',
  version: '1.0.0',
  env: ENV,
  isDev: IS_DEV,
  isProd: IS_PROD
}

// 分页配置
const PAGINATION = {
  defaultPage: 1,
  defaultLimit: 20,
  pageSizes: [10, 20, 50, 100]
}

// 文件上传配置
const UPLOAD = {
  maxSize: 5 * 1024 * 1024, // 5MB
  allowedTypes: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
  maxCount: 9
}

export {
  API_CONFIG,
  APP_CONFIG,
  PAGINATION,
  UPLOAD
}

export default {
  API_CONFIG,
  APP_CONFIG,
  PAGINATION,
  UPLOAD
}
